import { Outlet } from "react-router-dom";
import {
   TopBar,
   Navbar,
   Footer} from 
  '../components/web-app/index'

  import BackToTop from "./BackToTop/backtotop";
import WhatsAppButton from "./WatsapButton/Watsapbutton";

const WebWrapperLayout = () => {
  return (
    <>
      <TopBar />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer /> 
      <BackToTop /> 
      <WhatsAppButton/> 
    </>
  );
};

export default WebWrapperLayout;